import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { getTranslation, isSwedish } from '../../constants/languages';

/*
- CallHeader translations could not hit any case in the old code but were referred to
  and so but are here nevertheless if they were meant to be somehow included
*/

type CallHeaderOldProps = {
  iimclient: ConfigClientType;
};

const CallHeader = {
  lang_no: 'Bli oppringt',
  lang_se: 'Bli uppringd',
  lang_fi: 'Jätä soittopyyntö',
  lang_dk: 'Bestil opkald',
  lang_en: 'Call me back',
}

const CallHeaderOld = ({ iimclient }: CallHeaderOldProps) => {
  const { lang } = iimclient;

  const callHeader = getTranslation(lang, CallHeader);

  return (
    <span className="heading" id="call-header">
      {callHeader}
    </span>
  );
};

export default CallHeaderOld;
